module.exports = __webpack_public_path__ + "static/media/facedetect.f80c51e8.PNG";